import { render, staticRenderFns } from "./SasvStatus.vue?vue&type=template&id=6b0e5fcd"
import script from "./SasvStatus.vue?vue&type=script&lang=js"
export * from "./SasvStatus.vue?vue&type=script&lang=js"
import style0 from "./SasvStatus.vue?vue&type=style&index=0&id=6b0e5fcd&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports